import {
  MEMBER_DATA_SOURCE,
  MEMBER_DERIVED_LOB,
  MEMBER_STATE_CODE,
} from '../../constants/memberConstants';
import { useAppContext } from '../../store';
import useAEM from '../../AEM';
import { COMMON_COMPONENTS } from '../../AEM/constants';
import { useAEMContext } from '../../store/aemStore';
import { IAPIHeaders } from '../../API/utils';
import { IHoursOfOperation } from '../../store/interface';
import { parseHtml } from '../../helpers/htmlHelper';
import { removePtagFromHtml } from '../../AEM/utils';
import {
  CUSTOMER_SERVICE_NUMBER_PLACEHOLDER,
  PRODUCER_SERVICE_NUMBER_PLACEHOLDER,
} from '../../constants/common';
import useUserType from '../useUserType';

const useContactDetails = () => {
  const { memberDetails } = useAppContext();
  const { AEMCommonContent } = useAEMContext();
  const { getCommonContent } = useAEM();
  const {
    getStateCodeCustomerServiceNumberByUserType,
    getStateCodeProducerServiceNumberByUserType,
  } = useUserType();

  const { memberBillingInfoRequestPayload } = memberDetails;
  const { dataSource, derivedLob, state } =
    memberBillingInfoRequestPayload ?? {};

  const {
    hoursOfOperation: {
      label: {
        pdpHoursOfOperation,
        mapdHoursOfOperation,
        tmgMedsuppHoursOfOperation,
        vmsMedsuppHoursOfOperation,
      },
    },
  } = AEMCommonContent;

  const getHoursOfOperationDetailsForGov = ({
    stateParam,
  }: {
    stateParam?: MEMBER_STATE_CODE;
  }) => {
    const memberStateParam = stateParam
      ? stateParam
      : (state as MEMBER_STATE_CODE);
    const headers: IAPIHeaders = { STATE_CODE: memberStateParam };
    getCommonContent(COMMON_COMPONENTS.HOURS_OF_OPERATION, headers);
  };

  const getHoursOfOperationMessageForGov = ({
    derivedLobParam,
    dataSourceParam,
    errorContent,
    isAuthenticatedError,
  }: {
    derivedLobParam?: MEMBER_DERIVED_LOB;
    dataSourceParam?: MEMBER_DATA_SOURCE;
    errorContent?: IHoursOfOperation;
    isAuthenticatedError?: boolean;
  }) => {
    const memberDataSource = dataSourceParam ? dataSourceParam : dataSource;
    const memberDerivedLob = derivedLobParam ? derivedLobParam : derivedLob;
    if (memberDerivedLob && memberDataSource) {
      if (
        memberDataSource === MEMBER_DATA_SOURCE.VMS &&
        memberDerivedLob === MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE_SUPPLEMENTAL
      ) {
        return isAuthenticatedError
          ? errorContent?.label.vmsMedsuppHoursOfOperation
          : vmsMedsuppHoursOfOperation;
      } else if (memberDataSource === MEMBER_DATA_SOURCE.TMG) {
        if (
          memberDerivedLob ===
          MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE_SUPPLEMENTAL
        ) {
          return isAuthenticatedError
            ? errorContent?.label.tmgMedsuppHoursOfOperation
            : tmgMedsuppHoursOfOperation;
        } else if (memberDerivedLob === MEMBER_DERIVED_LOB.GOVERNMENT_PDP) {
          return isAuthenticatedError
            ? errorContent?.label.pdpHoursOfOperation
            : pdpHoursOfOperation;
        } else if (
          memberDerivedLob === MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE
        ) {
          return isAuthenticatedError
            ? errorContent?.label.mapdHoursOfOperation
            : mapdHoursOfOperation;
        }
        return '';
      }
      return '';
    }
    return '';
  };

  const getAutopayAlertForBroker = (brokerAutopayAssistanceAlert: string) => {
    return parseHtml(
      removePtagFromHtml(
        brokerAutopayAssistanceAlert
          .replace(
            CUSTOMER_SERVICE_NUMBER_PLACEHOLDER,
            getStateCodeCustomerServiceNumberByUserType(),
          )
          .replace(
            PRODUCER_SERVICE_NUMBER_PLACEHOLDER,
            getStateCodeProducerServiceNumberByUserType(),
          ),
      ),
    ) as string;
  };

  return {
    getHoursOfOperationDetailsForGov,
    getHoursOfOperationMessageForGov,
    getAutopayAlertForBroker,
  };
};

export default useContactDetails;
